import React, { Component } from 'react';
import dayjs from 'dayjs';
import { TableGrid } from '@C/TableGrid';
import services from '@C/Director/Packages/_utils/data';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';

const col = [
  {
    name: 'Package',
    key: 'plan',
  },
  {
    name: 'Features',
    key: 'packages',
    formatter(props) {
      return (
        <ul className="package-list">
          {props.map((item, index) => (
            <li key={index}>{item.module}</li>
          ))}
        </ul>
      );
    },
  },
];

export default class ExistingPackages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      existingPackages: [],
      loading: true,
    };
  }

  componentDidMount() {
    this.getPackages();
  }

  getPackages = () => {
    services
      .getPackages()
      .then((response) => {
        const tmp = response.data.data;
        const packageList = tmp.map((item) => {
          return {
            created_on: dayjs(item.created_on).format('DD/MM/YYYY'),
            plan: item.plan,
            packages: item.packages,
          };
        });

        this.setState({
          existingPackages: packageList,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    const { existingPackages, loading } = this.state;

    return (
      <>
        <section className="widget full-width list-table">
          <header>
            <h3> Existing Plans </h3>
          </header>
          <main className="list-content">
            <div className="table-wrapper --full">
              {loading ? (
                <DropLoaderLarge />
              ) : (
                <TableGrid
                  col={col}
                  row={existingPackages}
                  hideActions={true}
                  pagination="disabled"
                  enableExport={false}
                />
              )}
            </div>
          </main>
        </section>
      </>
    );
  }
}
